import React, { useState } from "react";
import ProjectCard from "../../components/cards/ProjectCard";
import ComingSoonModal from "../../components/ui/ComingSoonModal";

import ukaiThumb from "../../assets/images/syndrome_ukai.png";
import payrollThumb from "../../assets/images/payroll_system.png";
import cctvThumb from "../../assets/images/ai_box_meister.png";
import emsThumb from "../../assets/images/ems_energitimur.png";

function FeaturedProjectsSection() {
  const [activeProject, setActiveProject] = useState(null);

  const projects = [
    {
      title: "Syndrome UKAI",
      category: "Digital Learning Platform",

      summary:
        "A production-grade digital learning platform for pharmacist competency preparation, providing a unified ecosystem across web, Android, and iOS with learning modules, online tryouts, video courses, and an integrated AI assistant.",

      businessImpact:
        "Supporting more than 6,000 registered users through a scalable multi-platform ecosystem designed for online learning, competency preparation, and digital assessments.",

      techStack: [
        "Python",
        "Flask",
        "Golang",
        "React.js",
        "Next.js",
        "PostgreSQL",
      ],

      thumbnail: ukaiThumb,

      caseStudyUrl: "/projects/syndrome-ukai",

      siteUrl: "https://ukaisyndrome.id",

      playStoreUrl:
        "https://play.google.com/store/apps/details?id=com.ukaisyndrome.app",

      appStoreUrl: "https://apps.apple.com/us/app/syndrome-ukai/id6776521389",
    },

    {
      title: "Attendance & Payroll System",

      category: "Enterprise Software",

      summary:
        "An enterprise workforce management system designed to automate attendance tracking, payroll processing, leave management, overtime calculation, and employee administration through role-based workflows.",

      businessImpact:
        "Improved operational efficiency by reducing manual payroll processing, simplifying attendance management, and supporting accurate workforce administration.",

      techStack: ["Python", "Flask", "React.js", "PostgreSQL", "REST API"],

      thumbnail: payrollThumb,

      caseStudyUrl: "/projects/attendance-payroll",

      siteUrl: "https://berkahangsana.com",
    },

    {
      title: "AI CCTV Box – Abnormal Behavior Detection",

      category: "Applied Artificial Intelligence",

      summary:
        "An AI-powered CCTV analytics system developed to detect abnormal human behavior in real time by combining computer vision models with edge-based video processing for intelligent surveillance.",

      businessImpact:
        "Improved operational monitoring by enabling automated abnormal behavior detection, reducing reliance on continuous manual CCTV observation while providing faster incident awareness.",

      techStack: ["Python", "PyTorch", "YOLO", "OpenCV", "REST API"],

      thumbnail: cctvThumb,

      caseStudyUrl: "/projects/executive-information-system",
    },

    {
      title: "Energy Monitoring System",

      category: "Real-Time IoT Platform",

      summary:
        "A real-time energy monitoring platform designed to collect, process, and visualize electrical sensor data, enabling continuous monitoring of voltage, current, power consumption, and system performance.",

      businessImpact:
        "Provided near real-time operational visibility through IoT data processing pipelines and interactive dashboards, supporting efficient monitoring of electrical infrastructure.",

      techStack: ["Python", "Flask", "React.js", "IoT", "PostgreSQL"],

      thumbnail: emsThumb,

      caseStudyUrl: "/projects/energy-monitoring-system",

      siteUrl: "https://ems.energitimur.com/",
    },
  ];

  return (
    <section
      id="projects"
      className="bg-transparent p-4 sm:p-8 font-sans border-t border-slate-900/10 mt-12"
    >
      <div className="mx-auto max-w-7xl w-full">
        {/* Section Header */}
        <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-gsf-bronze">
              Selected Engineering Projects
            </span>
            <h2 className="mt-1 text-3xl font-black tracking-tight text-slate-900 sm:text-4xl">
              Engineering Case Studies
            </h2>
          </div>
          <p className="max-w-md text-sm font-medium text-slate-600 md:text-right">
            A selection of production systems, enterprise applications, and AI
            solutions that reflect my approach to building reliable software
            with measurable business value.
          </p>
        </div>

        {/* Container Stack Kartu Vertikal */}
        <div className="space-y-12">
          {projects.map((project, index) => (
            <ProjectCard
              key={index}
              title={project.title}
              category={project.category}
              summary={project.summary}
              businessImpact={project.businessImpact}
              techStack={project.techStack}
              thumbnail={project.thumbnail}
              caseStudyUrl={project.caseStudyUrl}
              siteUrl={project.siteUrl}
              playStoreUrl={project.playStoreUrl}
              appStoreUrl={project.appStoreUrl}
              isReversed={index % 2 !== 0}
              onDetailClick={() => setActiveProject(project.title)}
            />
          ))}
        </div>
      </div>

      {/* Render Modal Global di Bagian Bawah Section */}
      <ComingSoonModal
        isOpen={activeProject !== null}
        onClose={() => setActiveProject(null)}
        projectTitle={activeProject || ""}
      />
    </section>
  );
}

export default FeaturedProjectsSection;
